import { TipoPago } from "src/views/dataTienda/abonosPasarela/utils/types/TipoPago";
import { AbonoPasarela } from "../../bussines/entities/AbonoPasarela";

export class AbonoPasarelaModel implements AbonoPasarela {
    constructor(
        public idAbono: number,
        public idAbonoPasarela: string,
        public fechaAbono: Date,
        public totalAbono: number,
        public codMoneda: string,
        public estadoAbono: string,
        public nroLinea: number,
        public idPago: number | null,
        public docIdentidadCliente: string | null,
        public nombreRazonSocialCliente: string | null,
        public documento: string,
        public fechaEmisionComprobante: Date | null,
        public montoOperacion: number,
        public tipoOperacionPasarela: string,
        public montoNetoAbonado: number,
        public montoIgv: number,
        public comision: number,
        public fechaOperacion: Date,
        public tipoPago: TipoPago | null,
        public urlPdf: string | null
    ) { }

    serialize(): AbonoPasarela {
        return {
            idAbono: this.idAbono,
            idAbonoPasarela: this.idAbonoPasarela,
            fechaAbono: this.fechaAbono,
            totalAbono: this.totalAbono,
            codMoneda: this.codMoneda,
            estadoAbono: this.estadoAbono,
            nroLinea: this.nroLinea,
            idPago: this.idPago,
            docIdentidadCliente: this.docIdentidadCliente,
            nombreRazonSocialCliente: this.nombreRazonSocialCliente,
            documento: this.documento,
            fechaEmisionComprobante: this.fechaEmisionComprobante,
            montoOperacion: this.montoOperacion,
            tipoOperacionPasarela: this.tipoOperacionPasarela,
            montoNetoAbonado: this.montoNetoAbonado,
            montoIgv: this.montoIgv,
            comision: this.comision,
            fechaOperacion: this.fechaOperacion,
            tipoPago: this.tipoPago,
            urlPdf: this.urlPdf
        }
    }

    static deserialize(entity: AbonoPasarela): AbonoPasarelaModel {
        return new AbonoPasarelaModel(
            entity.idAbono,
            entity.idAbonoPasarela,
            entity.fechaAbono,
            entity.totalAbono,
            entity.codMoneda,
            entity.estadoAbono,
            entity.nroLinea,
            entity.idPago,
            entity.docIdentidadCliente,
            entity.nombreRazonSocialCliente,
            entity.documento,
            entity.fechaEmisionComprobante,
            entity.montoOperacion,
            entity.tipoOperacionPasarela,
            entity.montoNetoAbonado,
            entity.montoIgv,
            entity.comision,
            entity.fechaOperacion,
            entity.tipoPago,
            entity.urlPdf
        )
    }
}